import { render, staticRenderFns } from "./SummaryPropertySheet.vue?vue&type=template&id=979d037a"
import script from "./SummaryPropertySheet.vue?vue&type=script&lang=js"
export * from "./SummaryPropertySheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports